/**
 * Created by mike on 11/23/2016.
 */
jQuery(document).ready(function() {
    if( jQuery( '.gfield_total' ).length > 0 ) {
        if(!jQuery('body').hasClass('fl-builder-mobile')) {
            scrollRegisterToday();
        }
    }
});
// Function to scroll the register today button when the user scrolls
function scrollRegisterToday() {
    var $to_scroll	= jQuery( '.gfield_total' ),
        $window		= jQuery( window ),
        offset		= $to_scroll.offset(),
        topPadding	= 0;
    $window.scroll( function() {
        if( $window.scrollTop() > offset.top ) {
            $to_scroll.stop().animate( {
                marginTop: $window.scrollTop() - offset.top + topPadding
            });
        }else {
            $to_scroll.stop().animate( {
                marginTop: 230
            });
        }
    });
}